import React, { useState, useEffect, useCallback } from "react";
import {
  Link as RouterLink,
  useLocation,
} from "react-router-dom";

// NavLinksShow component to render navigation links
const NavLinksShow = ({ item, index, check }) => {
  // Get current location using react-router hooks
  const location = useLocation();

  // useCallback to memoize the active index calculation function
  const getActiveIndex = useCallback(() => {
    // Get the current pathname from location
    const pathname = location.pathname;
    // Check if the "faq" parameter is set to "true"
    if (pathname === "/punch-joke") {
      return 1; // Punch Joke link is active
    } else if (pathname === "/") {
      return 0; // Home link is active
    } else if (pathname === "/witrater") {
      return 2; // Witrater link is active
    } else if (pathname === "/get-setups") {
      return 3; // Get Setups link is active
    } else {
      return -1; // No link is active
    }
  }, [location]); // Dependencies for the useCallback

  // State to manage the active index
  const [active, setActive] = useState(0);

  // useEffect to update the active index when location changes
  useEffect(() => {
    setActive(getActiveIndex());
  }, [getActiveIndex]);

  return (
    // RouterLink component to navigate to the specified link
    <RouterLink
      to={`${item.link.toLowerCase()}`}
      onClick={() => setActive(index)} // Set the active index on click
      className={`${check ? "flex justify-center" : ""}`}
    >
      {/* Render the link title with appropriate styles based on the active index */}
      <p
        className={`text-[28px] font-extrabold cursor-pointer font-inter ${
          index === active ? "text-black border-[4px] border-black px-2 py-1 rounded-md" : "text-black"
        }`}
      >
        {item.title}
      </p>
    </RouterLink>
  );
};

export default NavLinksShow;
